<template>
  <div :class="'ui-spinner ui-spinner--' + size">
    <span class="side side-left">
      <span class="fill"></span>
    </span>
    <span class="side side-right">
      <span class="fill"></span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '',
    }
  }
}
</script>
